import { React, useEffect, useState } from 'react';
import { motion } from "framer-motion";
import GoToSimulation from '../../common/GoToSimulation';
import { rootRoute } from '../../../config';
import splashpagebg from '../assets/splash-page-bg.jpg';
import step1 from '../assets/step1.jpg';
import step2 from '../assets/step2.jpg';
import step3 from '../assets/step3.jpg';
import { useOutletContext, useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import ImModuleStyle from '../styles/im.module.css';
import review_doc from '../assets/review_doc.png';
import order_table from '../assets/order_table.png';
import calculator from '../assets/calculator.png';
import kpis from '../assets/kpis.png';
import step4im_easy from '../assets/step4im_easy.png';
import step4im_hard from '../assets/step4im_hard.png';
import track_costs_revenue from '../assets/track_costs_revenue.png';
import simulation_btn from '../assets/simulation_btn.png';

const Introduction = () => {
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader,setAriaProperty,check_Location] = useOutletContext();
  const navigate = useNavigate();
  const initIntro = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setHeaderPopup(false);
    setIsArtifacts(false);
  }
  const [currentSection, setCurrentSection] = useState(1);
  const handleContinueBtn = () => {
    if (currentSection <= 7) {
      setCurrentSection(currentSection + 1);
    }
  };
  const location = useLocation();
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    return (simObj?.currentstep > 0 || simObj?.attemptno > 1 || readStatusLength > 0 || simObj?.decisionHistory != null || simObj?.decisionHistory?.length != 0)
  }
  // const check_Location = () => { 
  //   const queryParams = new URLSearchParams(location.search);
  //   if (queryParams.has('from') && queryParams.get('from') == "footer") {
  //     navigate(`${rootRoute}/im`);
  //   } else {
  //     fuSkipWalkThruPopups() && navigate(`${rootRoute}/im/simulation`);
  //   }
  // }
  const checkNum = (num) => {
    return num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
  };
  useEffect(() => {
    initIntro();
    if (document.querySelector("footer.footer .container") != null) {
      if(fuSkipWalkThruPopups()){
      document.querySelector("footer.footer .container").style.justifyContent = "center";
      }
    }
    if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
      if(fuSkipWalkThruPopups()){
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "block";
      }
    }
    // if(document.querySelector(".continue-link") != null){
    //   if(fuSkipWalkThruPopups()){
    //     document.querySelector(".continue-link").style.justifyContent = "space-between";
    //   }
    // }
    if (document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").length>0) {
      document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
        item.style.display = "none"
      });
    }
    document.title = "Inventory Management | Introduction";
    return () => {
      if (document.querySelector("footer.footer .container") != null) {
        document.querySelector("footer.footer .container").style.justifyContent = "space-between";
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li:not(.skip-intro)") != null) {
        document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
          item.style.display = "block"
        });
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
      }
    }
  }, []);

  useEffect(() => {
   check_Location();
  }, [simObj]);
  return (
    <motion.div className={`${ImModuleStyle.intro} ${ImModuleStyle.sections}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${ImModuleStyle.section}`} style={{ display: currentSection >= 1 ? "block" : "none" }}>
        <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid}`}>
          <div className={`column ${ImModuleStyle.column}`}>
            <h2 className={`${ImModuleStyle['intro-heading']}`}>Introduction</h2>
            <h3 className={`${ImModuleStyle.situation}`}><strong>The Mission: </strong></h3>
            <div className={`${ImModuleStyle.content}`}>
              <p>You are the store manager at a local branch of a large electronics retail chain. A new version of a
                popular consumer electronics device called the Amulet
                is coming out this year. It is your job to sell as many
                Amulets as you can while minimizing your costs in order
                to maximize your store's profits.</p>
              <p className={`${ImModuleStyle.para}`}>The simulation will start after you place the first order
                and can be paused at any time. Your score will be calculated
                based on how well you do relative to your goal.</p>
              <h3 className={`${ImModuleStyle.goal}`}><strong>Your Goal: </strong></h3>
              <p>Earn {checkNum(simObj?.laststate?.yearlyProfitTarget)} in net profits of Amulet sales. Timeline 1 year!</p>
            </div>
          </div>
          <div className={`column ${ImModuleStyle.column}`}>
            <div className={`${ImModuleStyle.image}`}>
              <img src={splashpagebg} alt="" />
            </div>
            <div className={`${ImModuleStyle.instr} ${ImModuleStyle.box}`}>
              <p className={`${ImModuleStyle.bgblue}`}>The simulation will take approximately
                <strong> 25-45 minutes</strong> to complete and can be
                paused at any time.
              </p>
            </div>
          </div>
        </div>
        <hr aria-hidden="true" />
        <div
          className={`${ImModuleStyle['continue-link']}`}
          style={{ display: currentSection > 1 ? "none" : "flex" }}
        >
          {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/im/simulation`} className={`${ImModuleStyle['skip-intro']}`} role="button">
              <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
          <a href="#step1" onClick={handleContinueBtn} role="button">
            {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
          </a>
        </div>
      </div>
      <div className={`${ImModuleStyle.section}`} style={{ display: currentSection >= 2 ? "block" : "none" }}>
        <div className={`${ImModuleStyle.step}`} id="step1">
          <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid}`}>
            <div className={`column ${ImModuleStyle.column}`}>
              <h2>Step 1: Review Documents</h2>
              <div className={`${ImModuleStyle.content}`}>
                <p>First, you will need to go through your incoming documents, email, texts and voice messages in order to
                  familiarize yourself with the scenario specifics. Read
                  these items carefully since they contain clues on how to
                  best understand and solve problems. Be sure to check
                  new information, which is indicated with an alert <span className={`${ImModuleStyle['red-circle']}`} aria-hidden= "true" role='presentation'>2</span> <span className="sr-only">icon indicating 2 new items</span>.</p>
              </div>
            </div>
            <div className={`column ${ImModuleStyle.column}`}>
              <div className={`${ImModuleStyle.image}`}>
                <img src={review_doc} alt="An image displays a webpage with an open email dialog box showing a message, along with icons for memos, phone, and messages, and a list of emails." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ImModuleStyle['continue-link']}`}
            style={{ display: currentSection > 2 ? "none" : "flex" }}
          >
            {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/im/simulation`} className={`${ImModuleStyle['skip-intro']}`} role="button">
             <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
            <a href="#step2" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ImModuleStyle.section}`} style={{ display: currentSection >= 3 ? "block" : "none" }}>
        <div className={`${ImModuleStyle.step}`} id="step2">
          <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid}`}>
            <div className={`column ${ImModuleStyle.column}`}>
              <h2>Step 2: Make a Decision</h2>
              <div className={`${ImModuleStyle.content}`}>
                <p>Next, you will be asked to place your first order.
                  Make sure you review all of your materials so that
                  you can make the best decisions. You will be asked
                  to make additional ordering decisions that will
                  impact your revenue and costs over the course of
                  the simulation.</p>
              </div>
            </div>
            <div className={`column ${ImModuleStyle.column}`}>
              <div className={`${ImModuleStyle.image}`}>
                <img src={order_table} alt="An image displays a decision window of a webpage with an order form for a product, shipping options, order cost, and order history." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ImModuleStyle['continue-link']}`}
            style={{ display: currentSection > 3 ? "none" : "flex" }}
          >
            {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/im/simulation`} className={`${ImModuleStyle['skip-intro']}`} role="button">
              <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
            <a href="#step3" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ImModuleStyle.section} ${ImModuleStyle['calculator']}`} style={{ display: currentSection >= 4 ? "block" : "none" }}>
        <div className={`${ImModuleStyle.step}`} id="step3">
          <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid}`}>
            <div className={`column ${ImModuleStyle.column}`}>
              <h2>Step 3: Use of Calculator</h2>
              <div className={`${ImModuleStyle.content}`}>
                <p>You can choose to use the Calculator Tool to calculate your Economic Order Quantity and Reorder Point, to help you decide what to order and when.</p>
              </div>
            </div>
            <div className={`column ${ImModuleStyle.column}`}>
              <div className={`${ImModuleStyle.image}`}>
                <img src={calculator} alt="An image showing section of a webpage which displays a calculator tool to calculate your economic order quantity." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ImModuleStyle['continue-link']}`}
            style={{ display: currentSection > 4 ? "none" : "flex" }}
          >
            {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/im/simulation`} className={`${ImModuleStyle['skip-intro']}`} role="button">
             <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
            <a href="#step4" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ImModuleStyle.section} ${ImModuleStyle['watch-your-status']}`} style={{ display: currentSection >= 5 ? "block" : "none" }}>
        <div className={`${ImModuleStyle.step}`} id="step4">
          <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid}`}>
            <div className={`column ${ImModuleStyle.column}`}>
              <h2>Step 4: Watch Your Status</h2>
              <div className={`${ImModuleStyle.content}`}>
                <p>There are several different meters to judge how well you are doing.  They are located at the top of simulation screen.  They are the Units Left, Total Units Sold, Total Revenue, Total Costs, and Profit/Loss against your goal.</p>
              </div>
            </div>
            <div className={`column ${ImModuleStyle.column}`}>
              <div className={`${ImModuleStyle.image}`}>
                <img src={((simObj?.laststate?.level == "EASY") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)) ? step4im_easy : ((simObj?.laststate?.level == "HARD") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)) ? step4im_hard : kpis} alt="An image displays a section of a webpage with different meters to watch your status." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ImModuleStyle['continue-link']}`}
            style={{ display: currentSection > 5 ? "none" : "flex" }}
          >
            {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/im/simulation`} className={`${ImModuleStyle['skip-intro']}`} role="button">
             <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
            <a href="#step5" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ImModuleStyle.section}`} style={{ display: currentSection >= 6 ? "block" : "none" }}>
        <div id="step5" className={`${ImModuleStyle.step}`}>
          <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid}`}>
            <div className={`column ${ImModuleStyle.column}`}>
              <h2>Step 5: Track Costs and Revenues</h2>
              <div className={`${ImModuleStyle.content}`}>
                <p>As the simulation begins running, each 'day' takes
                  approximately 1 seconds. Your revenue and costs
                  will be charted in the bar chart on the top while
                  your inventory and demand will be charted in the
                  bar chart on the bottom. You will need to monitor
                  these to then inform making additional ordering
                  decisions.</p>
              </div>
            </div>
            <div className={`column ${ImModuleStyle.column}`}>
              <div className={`${ImModuleStyle.image}`}>
                <img src={track_costs_revenue} alt="An image showing section of a webpage with Revenue/Cost Graph and Inventory and Demand Graph." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ImModuleStyle['continue-link']}`}
            style={{ display: currentSection > 6 ? "none" : "flex" }}
          >
            {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/im/simulation`} className={`${ImModuleStyle['skip-intro']}`} role="button">
              <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
            <a href="#step6" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ImModuleStyle.section}`} style={{ display: currentSection >= 7 ? "block" : "none" }}>
        <div id="step6" className={`${ImModuleStyle.step}`}>
          <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid}`}>
            <div className={`column ${ImModuleStyle.column}`}>
              <h2>Step 6: Look for Hints</h2>
              <div className={`${ImModuleStyle.content}`}>
                <p>You can pause the simulation at any time by clicking the Pause Simulation button, and then click Resume Simulation to start again when you're ready.  Continue to keep an eye on your incoming notifications  to find hints and key information!</p>
              </div>
            </div>
            <div className={`column ${ImModuleStyle.column} ${ImModuleStyle['look-for-hints']}`}>
              <div className={`${ImModuleStyle.image}`}>
                <img src={simulation_btn} alt="An image showing section of a webpage to look for hints in simulation progress meter" />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ImModuleStyle['continue-link']}`}
            style={{ display: currentSection > 7 ? "none" : "flex" }}
          >
            {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/im/simulation`} className={`${ImModuleStyle['skip-intro']}`} role="button">
              <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
            <a href="#cardSec" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div style={{ display: currentSection >= 8 ? "block" : "none" }}>
        <div className="key-to-succ-sec">
          <div className={`${ImModuleStyle.bggray}`} id="cardSec">
            <div className={`${ImModuleStyle['keys-to-succ']}`}>
              <div style={{ "paddingTop": "20px" }}>
                <h2 className={`${ImModuleStyle['card-heading']}`}>Keys to Success</h2>
              </div>
              <div className={`${ImModuleStyle['card-wrapper']}`}>
                <div className={`ui card ${ImModuleStyle.ui} ${ImModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${ImModuleStyle.header} ${ImModuleStyle.aligned}`}>
                      <h3>Stay Informed</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${ImModuleStyle.content} ${ImModuleStyle.aligned}`}>
                    Your decisions are only as
                    good as the information they
                    are based on. Pay attention
                    to indicators and read new
                    messages as they come in.
                  </p>
                </div>

                <div className={`ui card ${ImModuleStyle.ui} ${ImModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${ImModuleStyle.header} ${ImModuleStyle.aligned}`}>
                      <h3>Be Adaptable</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${ImModuleStyle.content} ${ImModuleStyle.aligned}`}>
                    This simulation puts the
                    course concepts into a
                    real-world context where
                    circumstances are changing.
                    Don't be afraid to make
                    decisions when necessary.
                  </p>
                </div>

                <div className={`ui card ${ImModuleStyle.ui} ${ImModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${ImModuleStyle.header} ${ImModuleStyle.aligned}`}>
                      <h3>Be Patient</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${ImModuleStyle.content} ${ImModuleStyle.aligned}`}>
                    Sometimes the best course
                    of action is to see how your
                    decisions play out over
                    longer time periods.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <GoToSimulation />
        </div>
      </div>
    </motion.div>
  )
}

export default Introduction